document.addEventListener("turbolinks:load", function () {
    const toggle = document.querySelector("#create-assignment-dropdown-toggle-button");

    if (!toggle || toggle.dataset.vbDropdownBound === "true") return;

    toggle.dataset.vbDropdownBound = "true";
    setUpDropdown("#create-assignment-dropdown-toggle-button", ".assignments__create-dropdown-content");
});